import { AxiosError } from 'axios';
import {
  ITutorUserCreate,
  ITutorUserCreateOrContractPlanResponse,
} from 'types/TutorUser';

import { Api } from './api/axios.service';
import { TutorUserPlanService } from './tutor-user-plan.service';

/**
 * Create a tutor user
 *
 * @param {ITutorUserCreate} values
 * @return {*}  {Promise<ITutorUserCreateOrContractPlanResponse>}
 */
const createTutorUser = async ({
  cardHash,
  billingAddress,
  planId,
  ticket,
  holderName,
  cpf,
  ...values
}: ITutorUserCreate): Promise<any> => {
  try {
    const { data } = await Api.post<ITutorUserCreateOrContractPlanResponse>(
      '/tutor',
      {
        ...values,
        cardHash: cardHash ?? undefined,
        billingAddress: cardHash ? billingAddress : undefined,
        plan: cardHash ? planId : undefined,
        ticket: cardHash ? ticket : undefined,
        holderName: cardHash ? holderName : undefined,
        cpf: cardHash ? cpf : undefined
      }
    );

    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    const error = response?.data?.error;

    throw new Error(
      typeof error === 'string'
        ? error
        : 'Não foi possível concluir o seu cadastro'
    );
  }
};

/**
 * Request e-mail validation code on reqgister
 *
 * @param {(Pick<ITutorUserCreate, 'email' | 'name'>)} data
 * @return {*}  {Promise<void>}
 */
const requestEmailValidationCode = async (
  data: Pick<ITutorUserCreate, 'email' | 'name'>
): Promise<void> => {
  try {
   const response = await Api.post('/activationToken', data);
  } catch (reason) {
    const { response } = reason as AxiosError<any>;

    throw new Error(
      response?.data?.error || 'Não foi possível obter o código de validação'
    );
  }
};

export const TutorUserService = {
  createTutorUser,
  requestEmailValidationCode,
};
